const config = {
    company: {
        name: process.env.REACT_APP_COMPANY_NAME || 'HomeSanty',
        address: process.env.REACT_APP_COMPANY_ADDRESS || 'Av. Gonzalez Suarez SN y Cumandá, Cuenca, Ecuador',
        phone: process.env.REACT_APP_COMPANY_PHONE || '+593 099 193 6486',
        email: process.env.REACT_APP_COMPANY_EMAIL || 'contacto@homesanty.com',
        whatsapp: process.env.REACT_APP_WHATSAPP_PHONE || '593991936486',
    },
    social: {
        facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://facebook.com',
        instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://instagram.com',
        linkedin: process.env.REACT_APP_SOCIAL_LINKEDIN || 'https://linkedin.com',
    },
    tax: {
        percentage: Number(process.env.REACT_APP_TAX_PERCENTAGE) || 0.15,
    },
    api: {
        backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000',
    }
};

export default config;
